import React from "react";
import { Landmark, GraduationCap, ArrowRight } from "lucide-react";
import { TUITION, upcomingIntakes } from "./hcaData";
import { HcaReveal, HcaEyebrow, scrollToForm } from "./HcaReveal";

const Intakes = () => {
    const list = upcomingIntakes();
    return (
        <div className="rounded-2xl border border-[#D8DEE6] bg-white p-7" data-testid="hca-intakes-card">
            <p className="text-xs uppercase tracking-[0.18em] text-[#5E6B7E]">Upcoming intakes</p>
            {list.length ? (
                <ul className="mt-4 space-y-3">
                    {list.map((d, i) => (
                        <li key={d} className="flex items-center justify-between" data-testid={`hca-intake-${i}`}>
                            <span className="font-display text-lg text-[#0E1E3A]">{d}</span>
                            {i === 0 && <span className="text-[11px] font-semibold text-[#2E6F40] bg-[#2E6F40]/10 rounded-full px-2.5 py-1">Enrolling now</span>}
                        </li>
                    ))}
                </ul>
            ) : (
                <p className="mt-4 text-[#0E1E3A]">New intake dates coming soon — ask an advisor.</p>
            )}
        </div>
    );
};

export const HcaTuition = () => (
    <section data-testid="hca-tuition-section" className="max-w-7xl mx-auto px-6 py-20 lg:py-28 grid lg:grid-cols-12 gap-8">
        <HcaReveal className="lg:col-span-7 rounded-2xl bg-[#D4A140] p-8 sm:p-12 text-[#0E1E3A] relative overflow-hidden">
            <HcaEyebrow><span className="text-[#0E1E3A]/70">Investment</span></HcaEyebrow>
            <p className="font-display text-6xl sm:text-7xl mt-4" data-testid="hca-tuition-amount">{TUITION}</p>
            <p className="mt-2 text-[#0E1E3A]/80">Program tuition</p>
            <div className="mt-8 grid sm:grid-cols-2 gap-4">
                {[[Landmark, "BC Student Loan", "Eligible students can apply for StudentAid BC funding."], [GraduationCap, "Scholarships", "Ask about current scholarship opportunities."]].map(([Icon, t, d]) => (
                    <div key={t} className="rounded-xl bg-white/40 p-4">
                        <Icon className="h-5 w-5" />
                        <p className="font-semibold mt-2">{t}</p>
                        <p className="text-sm text-[#0E1E3A]/75">{d}</p>
                    </div>
                ))}
            </div>
            <button type="button" onClick={scrollToForm} data-testid="hca-tuition-cta-btn" className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#0E1E3A] text-white px-6 py-3 text-sm font-semibold hover:bg-[#13284d] transition-colors group">
                Check my funding options <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </button>
        </HcaReveal>
        <HcaReveal delay={0.1} className="lg:col-span-5 flex flex-col gap-6">
            <Intakes />
            <div className="rounded-2xl border border-[#D8DEE6] bg-white p-7">
                <p className="text-xs uppercase tracking-[0.18em] text-[#5E6B7E]">Attendance</p>
                <p className="mt-3 text-[#0E1E3A]">85% attendance is required to achieve competency and graduate.</p>
            </div>
        </HcaReveal>
    </section>
);
